const INITIAL_STATE = {
    data: null
}

const AgendaReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'agenda': {

            return {
                ...state,
                data: action.payload.agenda
            }
        }
        default: {
            return state
        }
    }
}

export default AgendaReducer